import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { ETokenStatus, IAppointment, IKIOSKModel, IkioskTokenType, IKioskMessage } from "../../../../models/kioskModel";
import { generateCheckInToken_Request, rePrintToken_Request } from "../../../../store/actions";
import { Ilanguages } from "../../../../models/utilitiesModel";
import { useTranslation } from "react-i18next";
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const AppoinmentsItem: React.FC<any> = ({ id }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const item: IAppointment = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.appointmentsData?.find((a: IAppointment) => a?.appointmentId === id)) || undefined;
    let currentDate = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.currentDateAndTime || new Date());
    const currentTime: string = moment(currentDate).format('DD/MM/YYYY HH:mm:ss');
    const minCheckinTime: string = moment(new Date(item?.appointmentTime))?.subtract(item?.minCheckinTime, 'minutes').format('DD/MM/YYYY HH:mm:ss');
    const maxCheckinTime: string = moment(new Date(item?.appointmentTime))?.add(item?.maxCheckinTime, 'minutes').format('DD/MM/YYYY HH:mm:ss');
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);

    let getScheduletime = () => {
        let schedletime: string;
        if (currentTime < minCheckinTime) {
            let timeDifferenceInMin = moment(minCheckinTime, 'DD/MM/YYYY HH:mm:ss').diff(moment(moment(currentTime, "DD/MM/YYYY HH:mm:ss")), "minutes");
            let timediff = timeDifferenceInMin + 1;
            schedletime = timediff > 60 ? Math.floor(timediff / 60) + " " + t('kiosktranslation.Hour' + language) + " " + timediff % 60 + " " + t('kiosktranslation.minutes' + language) : timediff + " " + t('kiosktranslation.minutes' + language);
        }
        else schedletime = "";
        return schedletime;
    }
    const handleCheckIn = (values: IAppointment) => {
        if (item?.serviceStatus === ETokenStatus.SCHEDULED) {
            dispatch(generateCheckInToken_Request(IkioskTokenType.CHECKIN, values.encounterId));
        }
        else dispatch(rePrintToken_Request(IkioskTokenType.CHECKIN, values.encounterId));
    };
    return (
        <div className={(((item?.serviceStatus === ETokenStatus.SCHEDULED) && (currentTime >= maxCheckinTime)) || ((item?.serviceStatus === ETokenStatus.SCHEDULED) && (minCheckinTime > currentTime))) ? 'appcard appcard_inactive' : 'appcard appcard_active'}>
            <div className='card-det'>
                <small>{moment(new Date(item?.appointmentTime)).format("hh:mm A")}</small>
                <h5>{(language === Ilanguages.ARB ? item?.branchNameAr : item?.branchNameEn)}</h5>
                <span>{item?.doctorName ? `Dr.${item?.doctorName}` : "-"}</span>
            </div>
            <button type="button" className='status_card d-flex flex-column kiosk_appointment_items' disabled={(item?.serviceStatus === ETokenStatus.SCHEDULED && (currentTime <= minCheckinTime || currentTime >= maxCheckinTime))} onClick={() => handleCheckIn(item)}>
                {(item?.serviceStatus === ETokenStatus.SCHEDULED) ? (getLabelConfigMsg(kioskConfigMsgs, language, "CheckIn") || t('kiosktranslation.CheckIn' + language)) : (getLabelConfigMsg(kioskConfigMsgs, language, "reprint") || t('kiosktranslation.reprint' + language))}
                {(item?.serviceStatus === ETokenStatus.SCHEDULED) && (minCheckinTime > currentTime) && <small>
                    {`${(getLabelConfigMsg(kioskConfigMsgs, language, "opensIn") || t("kiosktranslation.opensIn" + language))} ${getScheduletime()}`}
                </small>
                }
                {(item?.serviceStatus === ETokenStatus.SCHEDULED) && (currentTime >= maxCheckinTime) && <small>
                    {`${(getLabelConfigMsg(kioskConfigMsgs, language, "expired") || t("kiosktranslation.expired" + language))}`}
                </small>}
            </button>
        </div>
    )
}
export default React.memo(AppoinmentsItem);
